import React from 'react';
import PropTypes from 'prop-types';

/**
 * Abstracts away the gross-ness of using the raw HTML supplied by the Vistaprint pricing service
 */
function Price(props) {
  const {
    priceHTML,
    ...restProps
  } = props;

  return (
    <span
      {...restProps}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: priceHTML }}
    />
  );
}

Price.propTypes = {
  priceHTML: PropTypes.string.isRequired,
};

export default Price;



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Price.js